export default "__VITE_PUBLIC_ASSET__cabc4c5e__"